import { useEffect, useState } from "react";

import {
  ArrowButton,
  Label,
  TableMetadata,
  useTable,
} from "@king-ict/eupisi-ui/components";
import { hrDate } from "@king-ict/eupisi-ui/utils";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

import { getSchoolYearList } from "../../api/SchoolYear/SchoolYearApi";
import {
  ContentArea,
  ListTable,
  SearchCard,
  ToolbarTop,
} from "../../components";
import { SchoolYear } from "../../models/SchoolYear";
import { editImportantDateUrl } from "../../routes/routes";

export function SchoolYearList() {
  const { t } = useTranslation();
  const history = useHistory();

  const [tableData, setTableData] = useState<SchoolYear[]>([]);

  const tableMetadata: TableMetadata<SchoolYear> = {
    rowKey: "id",
    columns: [
      {
        headerClassName: "col-2",
        columnKey: "name",
        header: t("common.schoolYearModel.name"),
        accessor: "name",
      },
      {
        headerClassName: "col-2",
        columnKey: "code",
        header: t("common.schoolYearModel.code"),
        accessor: "code",
      },
      {
        headerClassName: "col-2",
        columnKey: "dateFrom",
        header: t("common.schoolYearModel.dateFrom"),
        accessor: (d: SchoolYear) => {
          return hrDate(new Date(d.dateFrom));
        },
      },
      {
        headerClassName: "col-2",
        columnKey: "dateTo",
        header: t("common.schoolYearModel.dateTo"),
        accessor: (d: SchoolYear) => {
          return hrDate(new Date(d.dateTo));
        },
      },
      {
        headerClassName: "col-2",
        cellClassName: "text-center",
        columnKey: "isCurrent",
        header: t("common.schoolYearModel.isCurrent"),
        accessor: (d: SchoolYear) => {
          return (
            <div className={"d-flex text-center"}>
              <Label
                color={d.isCurrent ? "success" : "noted-2"}
                className="text-center"
                outline={false}
              >
                {d.isCurrent ? t("common.yes") : t("common.no")}
              </Label>
            </div>
          );
        },
      },
      {
        headerClassName: "col-1 text-right",
        columnKey: "details",
        header: t("common.importantDateModel.name"),
        accessor: (d: any) => {
          return (
            <div className={"text-right"}>
              <ArrowButton
                ariaLabel={t("common.details")}
                onClick={() => handleDetailsClicked(d.id)}
              />
            </div>
          );
        },
      },
    ],
    rowToolTip: () => undefined,
  };

  useEffect(() => {
    (async () => {
      var result = (await getSchoolYearList()) as SchoolYear[];
      if ((result as SchoolYear[]) && result.length > 0) {
        setTableData(result);
      }
    })();
  }, []);

  const [tableProps] = useTable({
    metadata: tableMetadata,
    data: tableData,
    pagination: false,
    paginationPage: undefined,
    paginationPageSize: undefined as any,
    totalItems: 1,
    defaultSort: {},
  });

  const handleDetailsClicked = (id?: number) => {
    if (id) {
      history.push(editImportantDateUrl(id!));
    }
  };

  return (
    <ContentArea>
      <ToolbarTop pageTitle={t("navigation.schoolYearList")}></ToolbarTop>
      <SearchCard hideSearchBox={true}></SearchCard>
      <ListTable tableProps={tableProps} />
    </ContentArea>
  );
}
